<template>
  <div>
    <formTitle title="申請人語言 Applicant’s Language"></formTitle>
    <div class="box">
    <template v-for="(items, indexs) in applicantLanguage.applicantLanguages">
      <el-row type="flex" align="middle" v-if="indexs % 3 == 0" :key="indexs">
        <el-col
          :span="8"
          v-for="(y, e) in applicantLanguage.applicantLanguages.slice(
            indexs,
            indexs + 3
          )"
          :key="e"
        >
          <div>
            <div class="label-text">{{ setLabel(e) }}</div>
            <el-radio-group v-model="items.LanguageType">
              <template v-for="(item, index) in applicantLanguages">
                <el-radio
                  :key="index"
                   :disabled="true"
                  v-if="items.LanguageType == item.value"
                  :label="item.value"
                  >{{ item.label }}

                  <el-input
                    class="radio-input"
                    v-if="item.value == 3"
                    :disabled="items.LanguageType !== 3"
                    v-model="items.language"
                  ></el-input>
                </el-radio>
              </template>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
    </template>
    </div>
    <formTitle title="報讀科目 Subjects Applied"></formTitle>
    <template v-if="isElectiveSubjects()">
      <p>
        申請入讀通階二或通階三
        (中四或中五)者必須修讀四個核心科目及在上述名單中修讀三個選修科，數學科延伸單元(一或二)可以選修為第四個選修科，修讀選修科組合之最終決定須視乎本校時間表是否許可。
      </p>
      <p>
        Applicants applying for MS2/MS3 (S4/S5) must take all four core subjects
        and three elective subjects from the list and Mathematics Extended Part
        (Module 1 or Module 2) could be selected as the fourth elective subject.
        Elective subject combinations offered are subject to availability.
      </p>
    </template>
    <template v-if="isElectiveSubjects()">
      <div class="subjectsApplied-box">
        <div class="plain-button-title">核心科目 Core</div>
        <div class="subjectsApplied-content">
          <el-checkbox-group v-model="subjectsApplied.core">
            <template v-for="(item, index) in checkboxGroup">
              <el-row
                v-if="index % 2 == 0"
                :key="index"
                :gutter="20"
                type="flex"
                align="middle"
              >
                <el-col
                  v-for="(v, k) in checkboxGroup.slice(index, index + 2)"
                  :key="k"
                  :span="12"
                >
                  <el-checkbox disabled :label="v" name="type"></el-checkbox
                ></el-col>
              </el-row>
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </template>
    <template v-if="isElectiveSubjects()">
      <div class="subjectsApplied-box">
        <div class="plain-button-title">選修科目 Electives</div>
        <p>Please choose 3 or 4 out of the following subjects:</p>
        <div class="subjectsApplied-content">
          <el-checkbox-group
            class="electives-checkbox-group"
            v-model="subjectsApplied.eletives"
          >
            <template v-for="(item, index) in checkboxGroupElectives">
              <el-row
                :gutter="10"
                type="flex"
                v-if="index % 2 === 0"
                :key="index"
              >
                <el-col
                  :span="12"
                  v-for="(v, k) in checkboxGroupElectives.slice(
                    index,
                    index + 2
                  )"
                  :key="k"
                >
                  <el-checkbox disabled :label="v" name="type"></el-checkbox>
                </el-col>
              </el-row>
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </template>
    <template v-if="isCoreSubject()">
      <p>
        申請人需要修讀三個核心科目(Core)及六個由組別一(Group 1)至組別六(Group
        6)選取的科目，其中包括高級程度(Higher Level)與標準程度(Standard
        Level)各三科。申請人需在組別一、組別二及組別五各選修一科，並在組別三及組別四至少選修一科；如不選修組別六的科目，申請人需在組別三或組別四中多選一科。
      </p>
      <p>
        The applicant must take all three Core subjects and six subjects
        selected from Group 1 to Group 6, three of which are Higher Level and
        three of which are Standard Level. one subject from Group 1, Group 2 and
        Group 5 and at least one subject from Group 3 AND Group 4. If Group 6
        subject is not selected, the applicant should select an additional
        subject from Group 3 OR Group 4.
      </p>
    </template>
    <template v-if="isCoreSubject()">
      <div class="subjectsApplied-box">
        <div class="plain-button-title">核心科目 Core</div>
        <div class="subjectsApplied-content">
          <el-checkbox-group v-model="subjectsApplied.core">
            <template v-for="(item, index) in IBDPCore">
              <el-row
                v-if="index % 2 == 0"
                :key="index"
                :gutter="20"
                type="flex"
                align="middle"
              >
                <el-col
                  v-for="(v, k) in IBDPCore.slice(index, index + 2)"
                  :key="k"
                  :span="12"
                >
                  <el-checkbox  :disabled="true" :label="v" name="type"></el-checkbox
                ></el-col>
              </el-row>
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </template>
    <template v-if="isCoreSubject()">
      <div class="subjectsApplied-box">
        <div class="plain-button-title">選修科目 Other Subjects</div>
        <p>
          Please choose at least one subject from each group, except for Group
          6.
        </p>
        <div class="subjectsApplied-content">
          <el-row type="flex" align="middle">
            <el-col :span="12"> </el-col>
            <el-col :span="6" style="text-align: center;" class="subjects-title">
              Standard Level
            </el-col>
            <el-col :span="6" style="text-align: center;" class="subjects-title">
              Higher Level
            </el-col>
          </el-row>
          <div
            class="group-list"
            v-for="(items, indexs) in groupTypes"
            :key="indexs"
          >
            <el-row
              type="flex"
              v-for="(item, index) in setGroup(items)"
              :key="index"
              align="middle"
              class="row-middle"
            >
              <el-col :span="12">
                <div class="group-list-title subjects-title" v-if="index == 0">
                {{ items.label }}
                </div>
                {{ item.subject }}
              </el-col>
              <el-col :span="6" style="text-align: center !important;">
                <el-checkbox
                  :disabled="true"
                  v-model="item.isSelectedStandardLevel"
                ></el-checkbox
              ></el-col>
              <el-col :span="6" style="text-align: center !important;"
                ><el-checkbox
                   :disabled="true"
                  v-model="item.isSelectedHigherLevel"
                ></el-checkbox>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import applicationFormat from "@/utils/applicationFormat";
import formTitle from "@/components/formTitle";
export default {
  mixins:[applicationFormat],
  components: { formTitle },
  props: {
    formType: {
      type: Number,
      default: 5,
    },
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
  },
  watch: {
    formLabelAlign: {
      handler(v) {
        if (v !== null) {
          this.applicantLanguage.applicantLanguages = JSON.parse(
            this.componentMethods(v.components, 5)
          );
          this.subjectsApplied = JSON.parse(
            this.componentMethods(v.components, 6)
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    groupOne() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 0;
      });
    },
    groupTwo() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 1;
      });
    },
    groupThree() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 2;
      });
    },
    groupFour() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 3;
      });
    },
    groupFive() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 4;
      });
    },
    groupSix() {
      return this.subjectsApplied.otherSubjects.filter((item) => {
        return item.groupType === 5;
      });
    },
  },
  data() {
    return {
      isChangeSubjects: false,
      groupTypes: [
        {
          label: "Group1",
          value: 0,
        },
        {
          label: "Group2",
          value: 1,
        },
        {
          label: "Group3",
          value: 2,
        },
        {
          label: "Group4",
          value: 3,
        },
        {
          label: "Group5",
          value: 4,
        },
        {
          label: "Group6",
          value: 5,
        },
      ],
      isChangeElectiveList: false,
      IBDPCore: [
        "Creativity, Action and Service",
        "Extended Essay",
        "Theory of Knowledge",
      ],
      checkboxGroup: [
        "English Language",
        "中國語文",
        "Mathematics Compulsory Part",
        "公民與社會發展",
      ],
      checkboxGroupElectives: [
        "Biology",
        "BAFS (Accounting)",
        "BAFS (Business Management)",
        "Chemistry",
        "Chinese History",
        "Chinese Literature",
        "Economics",
        "Geography",
        "History",
        "Information & Communication Technology",
        "Literature in English",
        "Mathematics Extended Part (Module 1)",
        "Mathematics Extended Part (Module 2)",
        "Music",
        "Physics",
        "Visual Arts",
      ],
      applicantLanguages: [
        {
          label: "英語 English",
          value: 0,
        },
        {
          label: "普通話 Putonghua",
          value: 1,
        },
        {
          label: "廣東話 Cantonese",
          value: 2,
        },
        {
          label: "其他 Others",
          value: 3,
        },
      ],
    };
  },
  methods: {
    setIs() {
      let selectedHigherLevelLength = this.subjectsApplied.otherSubjects.filter(
        (v) => {
          return v.isSelectedHigherLevel == true;
        }
      ).length;
      let selectedStandardLevelLength =
        this.subjectsApplied.otherSubjects.filter((v) => {
          return v.isSelectedStandardLevel == true;
        }).length;
      let groupType3 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 2 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType4 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 3 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType5 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 4 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType6 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 5 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      if (groupType6 > 0 && selectedHigherLevelLength != 3) {
        //弹出消息
        this.$message.error("请选择三个高级课程");
        return;
      }
      if (groupType6 > 0 && selectedStandardLevelLength != 3) {
        this.$message.error("请选择三个标準课程");
        return;
      }
      if (groupType5 == 0) {
        this.$message.error("请选择Group5 一门课程");
        return;
      }
      if (groupType6 == 0) {
        if (groupType4 < 2 && groupType3 < 2) {
          this.$message.error("请多选Group3一门课程或Group4一门课");
          return;
        }
      }
      if (groupType4 == 0 || groupType3 == 0) {
        this.$message.error("请选择Group3一门课程或Group4一门课");
        return;
      }
    },
    onSubjectsChange(v) {
      this.isChangeSubjects = false;
      let selectedHigherLevelLength = v.filter((v) => {
        return v.isSelectedHigherLevel == true;
      }).length;
      let selectedStandardLevelLength = v.filter((v) => {
        return v.isSelectedStandardLevel == true;
      }).length;
      if (selectedHigherLevelLength >= 3) {
        this.isChangeSubjects = true;
      }
      if (selectedStandardLevelLength >= 3) {
        this.isChangeSubjects = true;
      }
    },
    isSubjectsDisabled(item) {
      let isItem = item;
      if (this.isChangeSubjects) {
        if (!isItem) {
          return true;
        }
      }
    },
    setGroup(items) {
      let newGroup = [];
      switch (items.value) {
        case 0:
          newGroup = this.groupOne;
          break;
        case 1:
          newGroup = this.groupTwo;
          break;
        case 2:
          newGroup = this.groupThree;
          break;
        case 3:
          newGroup = this.groupFour;
          break;
        case 4:
          newGroup = this.groupFive;
          break;
        case 5:
          newGroup = this.groupSix;
          break;
      }
      return newGroup;
    },
    setLabel(index) {
      let newLabel = "";
      switch (index) {
        case 0:
          newLabel = "第一語言 First language";
          break;
        case 1:
          newLabel = "第二語言 Second language ";
          break;
        case 2:
          newLabel = "家中主要使用語言 Main language used at home";
          break;
      }
      return newLabel;
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0].value;
    },
    isElectiveSubjects(){
      if(this.formType == 4 || this.formType == 11){
        return true
      }
    },
    isCoreSubject(){
      if(this.formType == 5){
        return true
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.subjectsApplied-box {
  margin: 20px 0;
}
.subjectsApplied-content {
  padding: 2.5rem;
  //蓝色边框
  border: 1px solid #0094ff;
  border-radius: 5px;
}
.row-middle {
  padding: 0.625rem 0;
}
.group-list {
  padding: 0.625rem 0;
  border-bottom: 1px solid #ebeef5;
}
.group-list-title {
  margin-bottom: 0.625rem;
}
.label-text {
  margin-bottom: 0.625rem;
}
.subjects-title {
  font-weight: bold;
  font-size: 1.25rem;
}
.plain-button-title {
  margin-bottom: 0.625rem;
}
.box{
  margin: 20px 0;
}
::v-deep {
  .el-checkbox-group {
    align-items: inherit !important;
  }
}
</style>